import phoneIcon from "../images/footer/icons/01.png"
import emailIcon from "../images/footer/icons/02.png"
import locationIcon from "../images/footer/icons/03.png"
export const footerInfo =[
    {
      img:phoneIcon ,
      alt: "Phone-icon",
      text: "رقم الاتصال : +965-9723-3444"
    },
    {
      img: emailIcon,
      alt: "email-icon",
      text: "البريد الالكتروني: q8baqer@outlook.com"
    },
    {
      img: locationIcon,
      alt: "location-icon",
      text: "العنوان: الكويت."
    }
  ]